import { writable, readable } from "svelte/store";

export const registerXpage = writable([10,25,50,75,100]);
export const viewsXpages = writable(10);
export const autentificado = writable(false);


//export const prefix = readable('supermayen');
export const prefix = readable('ventas');

//export const urlapp = readable('http://localhost/web/ventas/public/');
//export const urlapi = readable('http://localhost/web/fel/mapi/');

export const urlapp = readable('https://shop.outletsgt.com/');
export const urlapi = readable('https://shop.outletsgt.com/mapi/');

//export const urlapp = readable('https://app.sismosoluciones.com/');
//export const urlapi = readable('https://app.sismosoluciones.com/mapi/');

//export const urlapi = readable('https://poutlets.sismosoluciones.com/mapi/');
//export const urlapi = readable('http://localhost/web/supermayen/api/');
//export const urlapi = readable('https://app.supermayen.com/api/');
//export const urlapi = readable('https://app.distemanuel.com/api/');

//export const theme = writable('OSCURO'); // CLARO / OSCURO
export const theme = writable('CLARO'); // CLARO / OSCURO

export const login = writable(false);
export const iduser = writable(false);
export const user = writable(false);
export const sucursal = writable(false);
export const superadmin = writable(false);

export const sucursalStore = writable([]);

export const miPermiso = writable({});

export const permisos = writable({});

export const permisos_struct = readable({
    'general':  {
                    'access':true,
                    'combos':false,
                },
    'usuarios': {
                    'access':false,
                    'viewSelf':false,
                    'edit':false,
                    'insert':false,
                    'delete':false,
                },
    'facturacion': 
                {
                    'access':false,
                    'insert':false,
                    'view':false,
                    'viewSelf':false,
                    'annul':false,
                    'cortedia':false,
                    'corteperiodo':false,
                    'cortediaselectuser':false,
                    'filtrodia':false,
                },
    'movimientos': 
                {
                    'access':false,
                },
    'lotes': 
                {
                    'access':false,
                    'edit':false,
                    'insert':false,
                    'delete':false,                   
                },                
    'productos': 
                {
                    'access':false,
                    'edit':false,
                    'insert':false,
                    'delete':false,
                    'kardex':false,
                    'export_existencias':false,
                    'corteperiodo':false,
                },
    'clientes': 
                {
                    'access':false,
                    'edit':false,
                    'insert':false,
                    'delete':false,
                }, 
    'configuraciones': 
                {
                    'access':false,
                },
    'permisos': 
                {
                    'access':false,
                    'edit':false,
                    'insert':false,
                    'delete':false,                    
                },
    'sucursales':
                {
                    'access':false,
                    'edit':false,
                },
    'tokenfel':
                {
                    'access':false,
                },
    'configglobal':
                {
                    'access':false,
                },
    'stats':
                {
                    'access':false,
                },                
});

export const permisos_title = writable([
    {
                    'name' : 'Generales',
                    'key' : 'general',
                    'access':'Acceso a la <span class="hightext">aplicación</span>',
                    'combos':'Mostrar usuario en los <span class="hightext">Campos Seleccionables</span>',
    },
    {
                    'name' : 'Usuarios',
                    'key' : 'usuarios',
                    'access':'<span class="hightext">Acceso</span> al área de usuarios',
                    'viewSelf':'Acceso solo a <span class="hightext">su usuario</span>',
                    'edit':'<span class="hightext">Editar</span> usuario',
                    'insert':'<span class="hightext">Crear</span> usuario',
                    'delete':'<span class="hightext">Eliminar</span> usuario',
    },
    {
                    'name' : 'Facturacion',
                    'key' : 'facturacion',
                    'access':'<span class="hightext">Acceso</span> al área de facturación',
                    'insert':'<span class="hightext">Crear</span> factura',
                    'view':'<span class="hightext">Ver</span> factura',
                    'viewSelf':'Acceso solo a <span class="hightext">sus facturas</span>',
                    'annul':'<span class="hightext">Anular</span> factura',
                    'cortedia':'Crear <span class="hightext">Corte diario</span>',
                    'corteperiodo':'Crear <span class="hightext">Corte por periodo</span>',
                    'cortediaselectuser':'<span class="hightext">Seleccionar usuario</span> en los Cortes diarios',
                    'filtrodia':'<i class="bi bi-plug-fill me-1 text-primary hightext" title="Acción" style="cursor:pointer;"></i>Filtrar <span class="hightext">fecha</span> del día automaticamente',
    },
    {
                    'name' : 'Movimientos',
                    'key' : 'movimientos',
                    'access':'<span class="hightext">Acceso</span> al área de movimientos',
                    'edit':'<span class="hightext">Editar</span> movimiento',
                    'insert':'<span class="hightext">Crear</span> movimiento',      
    },
    {
                    'name' : 'Lotes',
                    'key' : 'lotes',
                    'access':'<span class="hightext">Acceso</span> al área de lotes',
                    'edit':'<span class="hightext">Editar</span> lotes',
                    'insert':'<span class="hightext">Crear</span> lotes',
                    'delete':'<span class="hightext">Eliminar</span> Lote',
    },    
    {
                    'name' : 'Productos',
                    'key' : 'productos',
                    'access':'<span class="hightext">Acceso</span> al área de productos',
                    'edit':'<span class="hightext">Editar</span> producto',
                    'insert':'<span class="hightext">Crear</span> producto',
                    'delete':'<span class="hightext">Eliminar</span> producto',
                    'kardex':'Ver <span class="hightext">Kardex</span> del producto',
                    'export_existencias':'<span class="hightext">Exportar</span> existencias a excel',
                    'corteperiodo':'Crear <span class="hightext">Corte por periodo</span> de unidades',
    },
    {
                    'name' : 'Clientes',
                    'key' : 'clientes',
                    'access':'<span class="hightext">Acceso</span> al área de clientes',
                    'edit':'<span class="hightext">Editar</span> cliente',
                    'insert':'<span class="hightext">Crear</span> cliente',
                    'delete':'<span class="hightext">Eliminar</span> cliente',
    },
    {
                    'name' : 'Configuraciones',
                    'key' : 'configuraciones',
                    'access':'<span class="hightext">Acceso</span> al área de configuraciones',
    },
    {
                    'name' : 'Roles de usuario',
                    'key' : 'permisos',
                    'access':'<span class="hightext">Acceso</span> al área de roles de usuario',
                    'edit':'<span class="hightext">Editar</span> roles de usuario',
                    'insert':'<span class="hightext">Crear</span> roles de usuario',
                    'delete':'<span class="hightext">Eliminar</span> roles de usuario',
                },
    {
                    'name' : 'Sucursales',
                    'key' : 'sucursales',
                    'access':'<span class="hightext">Acceso</span> al área de sucursales',
                    'edit':'<span class="hightext">Editar</span> sucursales',
    },
    {
                    'name' : 'Token FEL',
                    'key' : 'tokenfel',
                    'access':'<span class="hightext">Acceso</span> al área de Token FEL',
    },
    {
                    'name' : 'Configuraciones Globales',
                    'key' : 'configglobal',
                    'access':'<span class="hightext">Acceso</span> al área de Configuraciones Globales',
    },    
    {
                    'name' : 'Estadísticas',
                    'key' : 'stats',
                    'access':'<span class="hightext">Acceso</span> al área de Estadísticas',
    },    
]);